import { extend } from 'vee-validate'

extend('neres_letters_space_dash', {
  validate(value) {
    return /^[a-z \-'`’]*$/gi.test(value)
  },
  message: 'validations.neres_letters_space_dash'
})
extend('neres_birth_place', {
  validate(value) {
    return /^[a-z \-,.'`’]*$/gi.test(value)
  },
  message: 'validations.neres_birth_place'
})


extend('neres_letters_space_hyphen', {
  validate(value) {
    return /^[a-z \-'’`—–−]*$/gi.test(value)
  },
  message: 'validations.neres_letters_space_hyphen'
})
extend('neres_street_name', {
  validate(value) {
    return /^[0-9a-z \- .,/'`’]*$/gi.test(value)
  },
  message: 'validations.neres_street_name'
})
extend('neres_flat_number', {
  validate(value) {
    return /^[0-9a-z \-./'`ʼ’‘]*$/gi.test(value)
  },
  message: 'validations.neres_flat_number'
})

extend('neres_identify_code', {
  validate(value) {
    return /^[0-9a-z \- .]*$/gi.test(value)
  },
  message: 'validations.neres_identify_code'
})

extend('neres_state_region', {
  validate(value) {
    return /^[a-z \-'`’]*$/gi.test(value)
  },
  message: 'validations.neres_state_region'
})

extend('neres_registration_address', {
  validate(value) {
    return /^[0-9a-z ., «»„“”‹›〞〟"\-'`‘ʼ’()\/]*$/gi.test(value.replace(/\u200E/g, ''))
  },
  message: 'validations.neres_registration_address',
})
extend('neres_house', {
  validate(value) {
    return /^[0-9a-z \-./’'&quote;]*$/gi.test(value)
  },
  message: 'validations.neres_house'
})

extend('neres_letters_space_numeric', {
  validate(value) {
    return /^[0-9a-z .]*$/gi.test(value)
  },
  message: 'validations.neres_letters_space_numeric'
})
extend('neres_letters_space_numeric_dash', {
  validate(value) {
    return /^[0-9a-z .—–−\-]*$/gi.test(value)
  },
  message: 'validations.neres_letters_space_numeric_dash'
})

extend('neres_index', {
  validate(value) {
    return /^[0-9a-z \-]*$/gi.test(value)
  },
  message: 'validations.neres_index'
})

extend('neres_iban', {
  validate(value) {
    return /^[a-zA-Z]{0,2}[a-zA-Z0-9]{0,32}$/i.test(value)
  },
  message: 'validations.neres_iban'
})

extend('neres_address', {
  validate(value) {
    return /^[0-9a-z .,() \/ '`ʼ’‘—–−-]*$/gi.test(value)
  },
  message: 'validations.neres_address'
})
